export const TIPO_INSPECAO = {
  SIE: "SISE",
  ESC: "ESC",
  SIAPP: "SIAPP",
  SIM: "SIM",
  SIF: "SIF",
} as const;
